import React, {Component} from 'react';
import { translate } from 'react-i18next';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {NavControl} from 'modules/navigation/NavBarContainer';

import {initNavbarState} from 'actions/navbar.js';
import DatabaseService from 'services/DatabaseService.js';

import TeamChallenge from './TeamChallenge.js';


class TeamChallengeContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {busy:false, record:null};
        this.onClickDisband = this.onClickDisband.bind(this);
        this.onClickLeaderboardIcon = this.onClickLeaderboardIcon.bind(this);
        this.onContinue = this.onContinue.bind(this);
    }

    componentWillMount() {
        this.initNavigation();
        this.loadData();
    }

    initNavigation() {
        var title = this.props.t('Team Challenge');
        this.props.dispatch(initNavbarState({enable:true, menuEnable:false, backButtonEnable:false, rewardsEnable:false, title:title}));
        this.props.dispatch({type:'SET_SIDEBAR_ENABLE', enable:false});
    }

    loadData() {
        var recordId = this.props.match.params.id;
        this.setState({busy:true});
        DatabaseService.getTeamChallengeTeamInfo(recordId)
            .then((result)=> {
                this.setState({record:result.record});
            })
            .catch((error)=> {
                console.error('ERROR:');
                console.error(error);
            })
            .then(()=>{
                this.setState({busy:false});
            });
    }

    onClickDisband() {
        var recordId = this.props.match.params.id;
        this.props.dispatch({type:"SET_LOADING_OVERLAY_ENABLE", enable:true});
        DatabaseService.disbandTeamChallengeTeam(recordId)
            .then((result) => {
                this.props.history.push('/team-challenges');
            }).catch((error)=>{
                console.error("error - disbandTeamChallengeTeam", error);
            })
            .then(()=>{
                this.props.dispatch({type:"SET_LOADING_OVERLAY_ENABLE", enable:false});
            });
    }

    onClickLeaderboardIcon() {
        var record = this.state.record;
        if(record && record.leaderboard) {
            this.props.history.push('/leaderboards/'+record.leaderboard.id);
        }
    }

    onContinue() {
        this.props.history.goBack();
    }

    render() {
        var record = this.state.record;
        var myTeam = Boolean(this.props.me!=null && record!=null && this.props.me.id===record.userProfileId);
        var completeScreen = this.props.completeScreen;
        return <NavControl key="teamchallengestatus" onClose={completeScreen ? null : this.onContinue} onDone={this.onClickLeaderboardIcon} doneIconOpts={{key:'teamchallengestatus', className:'icon-leaderboard'}}>
                   <TeamChallenge busy={this.state.busy}
                              record={record}
                              onClickDisband={this.onClickDisband}
                              onContinue={this.onContinue}
                              myTeam={myTeam}
                              completeScreen={completeScreen} />
               </NavControl>
    }
}


const mapStateToProps = (state, ownProps) => {
    return {me:state.user.userProfile};
};
export default withRouter(connect(mapStateToProps)(translate('teamchallenges')(TeamChallengeContainer)));



// WEBPACK FOOTER //
// ./src/modules/teamchallenges/TeamChallengeContainer.js